"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const req_1 = require("../../../app/dist/req");
exports.toolDef = {
    name: 'loom_finalize_req',
    description: "Lock a thread's req doc: flips status \"draft\" → \"locked\" (the explicit anchor downstream idea/design/plan build against). Does not bump the version. Idempotent if already locked. To change a locked req later, use loom_amend_req (which re-opens it to draft and bumps the version under append-only rules). Use this tool to lock a req — do not edit weave files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread inside the weave' },
        },
        required: ['weave_slug', 'thread_ulid'],
    },
};
async function handle(root, args) {
    const result = await (0, req_1.finalizeReq)({
        weaveSlug: args['weave_slug'],
        threadUlid: args['thread_ulid'],
    }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
